<template>
  <div class="w-100 home-carousel">
    <v-row align="center" class="position-relative">
      <v-col cols="2" class="d-none d-sm-block">
        <v-img
          :src="require('@/assets/img/icons/icon-continuar-leyendo-2.png')"
          height="120"
          width="145"
          class="img-titles-absolute"
        ></v-img>
      </v-col>
      <v-col class="header-section pl-md-0">
        <h3>{{ $t('home.continue_with_your_reading') }}</h3>
        <p>{{ $t('home.assigned_books_and_by_own_taste')}}</p>
      </v-col>
      <v-col cols="auto" class="justify-content-end">
        <span class="fake-btn">
          <i aria-hidden="true" class="v-icon notranslate mdi mdi-chevron-left theme--dark" style="font-size: 24px;"></i>
        </span>
        <span class="fake-btn">
          <i aria-hidden="true" class="v-icon notranslate mdi mdi-chevron-right theme--dark" style="font-size: 24px;"></i>
        </span>
      </v-col>
    </v-row>

        <v-carousel
          cycle
          continuous
          height="auto"
          interval="30000"
          hide-delimiter-background
        >
        <v-carousel-item>
          <AssignedBook />
        </v-carousel-item>
        <template v-if="!load && readingBookListUser.data.length > 0">
          <v-carousel-item v-for="(favBook, i) in limitedFavoriteBooks" :key="i">
            <CarouselCards
              :id=favBook.book.id
              :imgSource="favBook.book.resourceDir"
              :title="favBook.book.title"
              :description="favBook.book.bookAbstract"
              :tag="$t('home.own_taste')"
              :endDate="10"
              :completedTasks="favBook.currentPage"
              :totalTasks="favBook.book.totalPages"
            />
          </v-carousel-item>
        </template>
        <v-carousel-item v-if="load">
          <v-row class="pa-0 ma-0">
            <v-col cols="4" md="4">
                <v-row justify="center">
                    <v-skeleton-loader
                        light
                        height="200"
                        width="230"
                        type="image"
                        :transition="'scale-transition'"
                    ></v-skeleton-loader>
                </v-row>
            </v-col>
            <v-col cols="8" md="8" class="">
                <v-skeleton-loader
                    light
                    class="mb-2"
                    width="40%"
                    type="heading"
                    :transition="'scale-transition'"
                ></v-skeleton-loader>
                <v-skeleton-loader
                    light
                    width="90%"
                    class="mb-2"
                    type="paragraph"
                    :transition="'scale-transition'"
                ></v-skeleton-loader>
                <v-skeleton-loader
                    light
                    height="70"
                    width="90%"
                    type="paragraph"
                    :transition="'scale-transition'"
                ></v-skeleton-loader>
            </v-col>
          </v-row>
        </v-carousel-item>
        <v-carousel-item v-if="!load && readingBookListUser.data.length == 0">
          <CarouselCardsEmpty />
        </v-carousel-item>
      </v-carousel>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import * as Sentry from '@sentry/vue'
import bookService from '../../services/book'

import AssignedBook from '@/components/home/AssignedBook.vue'
import CarouselCards from './CarouselCards.vue'
import CarouselCardsEmpty from './CarouselCardsEmpty.vue'
export default {
  components: {
    AssignedBook,
    CarouselCards,
    CarouselCardsEmpty
  },
  data () {
    return{
      readingBookListUser: {
          code: 0,
          data: [],
      },
      limitFavBooks: 3,
      loading: true,
      load: true,
    }
  },
  computed: {
    ...mapState({
        user_loaded: (state) => state.userData.user_loaded,
        user_id: (state) => state.userData.user.id,
    }),
    favoriteBookList() {
        return this.favoriteBookListUser
    },
    readingBooksByUser() {
        return this.readingBookListUser
    },
    limitedFavoriteBooks() {
      return this.readingBooksByUser.data.slice(0, this.limitFavBooks);
    }
  },
  created() {
    this.getReadingBooksByUser()
  },
  methods: {
    getFavoriteBooksList() {
      bookService
        .getBookListFavoriteByUser(this.user_id)
        .then((response) => {
          if (response.content.length > 0) {
            this.favoriteBookListUser = {
                code: 1,
                data: response.content,
            }
          } else {
            this.favoriteBookListUser = {
                code: 2,
                data: response.content,
            }
          }
          this.loading = false
        })
        .catch((error) => {
          Sentry.captureException(error)
          this.favoriteBookListUser = {
            code: 3,
            error,
          }
        })
    },
    getReadingBooksByUser() {
        bookService
            .getReadingBooksByUser(this.user_id)
            .then((response) => {
                if (response.content && response.content.length > 0) {
                    this.readingBookListUser = {
                        code: 1,
                        data: response.content,
                    }
                } else {
                    this.readingBookListUser = {
                        code: 2,
                        data: [],
                    }
                }
                this.load = false
            })
            .catch((error) => {
                Sentry.captureException(error)
                this.readingBookListUser = {
                    code: 3,
                    error,
                }
            })
    },
    prev() {
      // Lógica para ir al elemento anterior
      this.$refs.carousel.prev();
    },
    next() {
      // Lógica para ir al siguiente elemento
      this.$refs.carousel.next();
    },
  },
  mounted() {

  }
}
</script>

<style lang="scss" scoped>

@media only screen and (max-width: 992px) {
  ::v-deep .v-window__next,
  ::v-deep .v-window__prev{
    visibility: hidden;
  }
}
.img-titles-ab {
    position: absolute;
    top: -35px;
    left: 0;
}
.v-carousel{
  overflow: visible;
}
::v-deep .v-window__next,
::v-deep .v-window__prev{
  background: transparent;
  // border: 1px solid white;
  margin: 0;
  position: absolute;
  top: -58px;
  height: 36px;
  width: 36px;
  .v-icon.mdi{
    font-size: 24px!important;
  }
  @media screen and (max-width: 992px) {
    top: -69px;
  }
  @media screen and (min-width: 992px) and (max-width: 1140px) {
    top: -80px;
  }
}
::v-deep .v-window__prev{
  right: 56px;
  left: inherit;
}
::v-deep .v-window__next{
  right: 8px;
  .v-btn__content{
    margin-right: 1px;
  }
}
.fake-btn{
  align-items: center;
  background: transparent;
  border: 1px solid white;
  border-radius: 50%;
  display: inline-flex;
  justify-content: center;
  height: 36px;
  width: 36px;
  cursor: pointer;
  &:first-child{
    margin-right: 12px;
  }
  &:last-child{
    margin-right: 8px;
  }
}

::v-deep .v-carousel__controls{
  bottom: -45px;
  .theme--dark.v-btn.v-btn--icon{
    color: #D7D2EF;
    &.v-btn--active{
      color: #7764CA;
    }
  }
  .v-btn:not(.v-btn--text):not(.v-btn--outlined):hover:before{
    opacity: 1;
  }
  .v-carousel__controls__item .v-icon{
    opacity: 1;
  }
  .v-icon.v-icon{
    font-size: 16px!important;
  }
  .v-btn--icon.v-size--small{
    height: 16px;
    width: 16px;
  }
  @media screen and (min-width: 940px) {
    display: none;
  }
}
</style>
